import { atom } from "recoil";
import { localStorageEffect } from "./localStorage";

export const themeState = atom({
  key: "themeState", // unique ID (with respect to other atoms/selectors)
  default: "defaultTheme", // default value (aka initial value)
});

export const sideDrawerState = atom({
  key: "sideDrawerState", // unique ID (with respect to other atoms/selectors)
  default: "open", // default value (aka initial value)
  effects_UNSTABLE: [localStorageEffect("ui_menu")],
});

export const publishRequiredState = atom({
  key: "publishRequiredState",
  default: [],
  effects_UNSTABLE: [localStorageEffect("publish_alert")],
});

export const priceCheckDrawerState = atom({
  key: "priceCheckDrawerState", // unique ID (with respect to other atoms/selectors)
  default: "closed", // default value (aka initial value)
});

export const comparePlayerStatDrawerState = atom({
  key: "comparePlayerStatDrawerState",
  default: false,
});

export const comparePlayerStatsDataState = atom({
  key: "comparePlayerStatsDataState",
  default: {
    marketIds: null,
    statIds: null,
    selectedStatId: null,
  },
});
